var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('iframe',{ref:"iframeDom",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src,"frameborder":"0"},on:{"load":_vm.load}})])}
var staticRenderFns = []

export { render, staticRenderFns }